import React from 'react'
import { AuthoringUtils } from '@adobe/aem-spa-page-model-manager'
import { EditableComponent } from '@adobe/aem-react-editable-components'
import withComponentRefresh from '../../../utils/aem/editor/withComponentRefresh'
import { useExtractEditableProps } from '../../../utils/aem/editor/extractEditableProps'
import {
  withErrorBoundary,
  ErrorFallback
} from '../../functional/ErrorBoundary'
import type { EditableComponentPropsType } from '../../../utils/prop-types'
import type { CustomProductListModelProps } from './types'
import CustomProductListEditConfig from './CustomProductListEditConfig'
import Container from '../../templates/Container/Container'

const CustomProductList: React.FC<
  EditableComponentPropsType<CustomProductListModelProps>
> = withComponentRefresh<CustomProductListModelProps>((props) => {
  const { id, superTags, brand, dataLayerListName, ...rest } = props.model || {}
  const editableProps = useExtractEditableProps(props, rest)

  return (
    <EditableComponent {...editableProps}>
      {AuthoringUtils.isInEditor() &&
      CustomProductListEditConfig.isEmpty(props.model) ? (
        CustomProductListEditConfig.emptyLabel
      ) : (
        <>
          <pre>{JSON.stringify(props.model, null, 2)}</pre>
          <Container {...editableProps} />
        </>
      )}
    </EditableComponent>
  )
})

const CustomProductListWithErrorBoundary = withErrorBoundary(
  CustomProductList,
  {
    componentName: 'CustomProductList',
    fallback: <ErrorFallback componentName="CustomProductList" />
  }
)

export default CustomProductListWithErrorBoundary
